"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ELEMENT_LABELS_MAP = {};
function getElementLabels(type) {
    return ELEMENT_LABELS_MAP[type.toLowerCase()];
}
exports.getElementLabels = getElementLabels;
function registerElementLabels(type, ctor) {
    if (getElementLabels(type)) {
        throw new Error("ElementLabels type '" + type + "' existed.");
    }
    ELEMENT_LABELS_MAP[type.toLowerCase()] = ctor;
}
exports.registerElementLabels = registerElementLabels;
//# sourceMappingURL=factory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/controller/label/components/factory.js
// module id = 802
// module chunks = 37